import React from "react";
import { Dropdown, Icon } from "semantic-ui-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import Authorized from "components/Authorized";
import withRoleCheck from "components/hocs/withRoleCheck";
import CustomDropdown from "components/CustomDropdown";
import Link from "components/Link";
import { FORM_ORIGINS } from "routes/revenue_opportunity/paths";
import { useRevenueOpportunityNavigation } from "routes/revenue_opportunity/useRevenueOpportunityNavigation";
import {
  DeleteCampaignTargetModal as _DeleteCampaignTargetModal,
  EditCampaignTargetModal as _EditCampaignTargetModal,
} from "routes/campaign/components/Modals";

const EditCampaignTargetModal = withRoleCheck(_EditCampaignTargetModal, [
  ACL_RELATIONSHIPS.campaignTarget.edit,
]);
const DeleteCampaignTargetModal = withRoleCheck(_DeleteCampaignTargetModal, [
  ACL_RELATIONSHIPS.campaignTarget.delete,
]);

export function CampaignTargetTableActions({
  original,
  campaign,
  invalidateData,
  deleteCampaignTarget,
}) {
  const { openCreate } = useRevenueOpportunityNavigation();

  return (
    <CustomDropdown icon="ellipsis horizontal">
      <Dropdown.Menu direction="left">
        <EditCampaignTargetModal
          fetchCampaignTargets={invalidateData}
          campaignId={original.campaign_id}
          entityId={original.entity_id}
          menuTrigger
        />
        <DeleteCampaignTargetModal
          onConfirmDelete={() =>
            deleteCampaignTarget(original.campaign_id, original.entity_id)
          }
          menuTrigger
          modalMessage="Are you sure you want to delete this Campaign Target?"
          buttonText="Delete"
        />
        <Authorized permissions={[ACL_RELATIONSHIPS.revenueOpportunity.create]}>
          <Dropdown.Item
            onClick={() =>
              openCreate({
                origin: FORM_ORIGINS.campaignTarget,
                campaignId: original.campaign_id,
                entityId: original.entity_id,
              })
            }
          >
            <Icon name="plus" />
            New Revenue Opportunity
          </Dropdown.Item>
        </Authorized>
        <Dropdown.Item
          as={Link}
          to={{
            pathname: `/campaigns/${original.campaign_id}/target/${original.entity_id}`,
            state: {
              campaign_target_name: original.entity_name,
              campaign_name: campaign.name,
            },
          }}
        >
          <Icon name="eye" />
          View
        </Dropdown.Item>
      </Dropdown.Menu>
    </CustomDropdown>
  );
}
